import { css } from 'styled-components';
import theme from './theme';
import media from './media';

// prettier-ignore
export default {
  heroText: css`
    margin-bottom: ${theme.sp.xxs};
    font-size: 30px;
    line-height: 37px;

    ${media.tablet`
      font-size: 48px;
      line-height: 58px;
    `}
  `,

  headingText: css`
    font-size: 24px;
    line-height: 29px;
    margin-bottom: ${theme.sp.s};
    ${media.tablet`
      font-size: 36px;
      line-height: 43px;
    `}
  `,

  subheadingText: css`
    font-size: 14px;
    line-height: 18px;
    ${media.tablet`
      font-size: 18px;
      line-height: 23px;
    `}
  `,

  paragraphText: css`
    font-size: 14px;
    line-height: 21px;
    ${media.tablet`
      font-size: 18px;
      line-height: 27px;
    `}
  `
}



// WEBPACK FOOTER //
// ./src/styles/mixins.js